import React from 'react';
import cls from 'classnames';
import { IconComp } from '../IconComponent';

export enum BadgeSizes {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

export interface ISKBadgeProps {
  color: 'gray' | 'error' | 'warning' | 'success' | 'outline' | 'black' | undefined;
  iconLeft?: React.ReactType;
  iconRight?: React.ReactType;
  size: BadgeSizes;
  onlyIcon?: boolean | undefined;
  className?: string;
  iconSize?: number;
}

export const SKBadge: React.FC<ISKBadgeProps> = (props) => {
  const { color, iconLeft, iconRight, size, onlyIcon, className, iconSize } = props;
  return (
    <>
      {!onlyIcon && (
        <div
          className={cls(
            'inline-flex justify-center gap-x-1 items-center rounded-3xl cursor-default',
            {
              'bg-cloud-200 text-cloud-700': color === 'gray',
              'bg-strawberry-400 text-cloud-900': color === 'error',
              'bg-gold-300 text-cloud-900': color === 'warning',
              'bg-kiwi-400 text-black': color === 'success',
              'bg-white border border-cloud-900 text-cloud-900': color === 'outline',
              'bg-cloud-900 text-white': color === 'black',
              'px-1.5 py-0.5 font-medium text-xs': size === BadgeSizes.SM,
              'px-2 py-0.625 font-normal text-sm': size === BadgeSizes.MD,
              'px-2.5 py-1.5 font-normal text-base': size === BadgeSizes.LG,
            },
            className,
          )}
        >
          {iconLeft && (
            <IconComp
              className={cls('stroke-current', {
                'text-cloud-500': color === 'gray',
                'text-cloud-900':
                  color === 'error' || color === 'warning' || color === 'success' || color === 'outline',
                'text-white': color === 'black',
              })}
              icon={iconLeft}
              size={iconSize ? iconSize : 12}
            />
          )}
          {props.children}
          {iconRight && (
            <IconComp
              className={cls('stroke-current', {
                'text-cloud-500': color === 'gray',
                'text-cloud-900':
                  color === 'error' || color === 'warning' || color === 'success' || color === 'outline',
                'text-white': color === 'black',
              })}
              icon={iconRight}
              size={iconSize ? iconSize : 12}
            />
          )}
        </div>
      )}
      {onlyIcon && (
        <div
          className={cls('inline-flex justify-center gap-x-1 items-center rounded-full', {
            'bg-cloud-200': color === 'gray',
            'bg-strawberry-400': color === 'error',
            'bg-gold-300': color === 'warning',
            'bg-kiwi-400': color === 'success',
            'bg-white border border-cloud-900': color === 'outline',
            'bg-cloud-900': color === 'black',
            'p-1.5 font-medium': size === BadgeSizes.SM,
            'p-2 font-normal': size === BadgeSizes.MD,
            'p-3 font-normal': size === BadgeSizes.LG,
          })}
        >
          {iconRight && (
            <IconComp
              className={cls('stroke-current', {
                'text-cloud-500': color === 'gray',
                'text-cloud-900':
                  color === 'error' || color === 'warning' || color === 'success' || color === 'outline',
                'text-white': color === 'black',
              })}
              icon={iconRight}
              size={iconSize ? iconSize : 12}
            />
          )}
        </div>
      )}
    </>
  );
};
